<template>
    <!-- Sidebar -->
    <ul class=" bg-gradient-primary sidebar sidebar-dark accordion" id="accordionSidebar">

      <!-- Sidebar - Brand -->
  
      <router-link :to="{ name: 'Home'}" class="sidebar-brand d-flex align-items-center justify-content-center">
          <div class="sidebar-brand-text mx-3">CRCB Control Panel</div>
      </router-link>


      <!-- Divider -->
      <hr class="sidebar-divider my-0">

      <!-- Nav Item - Dashboard -->
      <li class="nav-item" >
        <router-link :to="{ name: 'Home'}" class="nav-link">
          <i class="fas fa-tachometer-alt"></i>
          <span>首頁</span>
        </router-link>
      </li>

      <!-- Nav Item - Pages Collapse Menu -->
      <li class="nav-item" v-if="permission.banner" :class="$route.name.indexOf('Banner') > -1  && $route.name.indexOf('en') == -1 ? 'active':''">
        <router-link :to="{ name: 'Banner'}" class="nav-link">
          <i class="fas fa-image"></i>
          <span>Banner管理</span>
        </router-link>
      </li>
      <li class="nav-item" v-if="permission.faculty" :class="$route.name.indexOf('Faculty') > -1 && $route.name.indexOf('en') == -1 ? 'active':''">
        <router-link :to="{ name: 'Faculty'}" class="nav-link">
          <i class="fas fa-user"></i>
          <span>中心成員管理</span>
        </router-link>
      </li>
      <li class="nav-item" v-if="permission.news || permission.category">
        <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#news" aria-expanded="true" aria-controls="news">
          <i class="fas fa-file"></i>
          <span>內容管理</span>
          
        </a>
        <div id="news" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionSidebar" :class=" ( $route.name.indexOf('News') > -1 || $route.name.indexOf('Category')  > -1 ) && $route.name.indexOf('en') == -1  ? 'show':''">
          <div class="bg-white py-2 collapse-inner rounded">
            <router-link :to="{ name: 'News'}" class="collapse-item" v-if="permission.news" :class="$route.name.indexOf('News') > -1 && $route.name.indexOf('en') == -1 ? 'active':''" >
              <span>內容列表</span>
            </router-link>
            <router-link :to="{ name: 'Category'}" class="collapse-item" v-if="permission.category" :class="$route.name.indexOf('Category') > -1 && $route.name.indexOf('en') == -1 ? 'active':''" >
              <span>類別管理</span>
            </router-link>
          </div>
        </div>
      </li>
      <li class="nav-item" v-if="permission.activity"  :class="$route.name.indexOf('Activity') > -1 && $route.name.indexOf('en') == -1 ? 'active':''">
        <router-link :to="{ name: 'Activity'}" class="nav-link">
          <i class="fas fa-camera"></i>
          <span>活動剪影管理</span>
        </router-link>
      </li>
      <li class="nav-item" v-if="permission.contact" :class="$route.name.indexOf('Contact') > -1 && $route.name.indexOf('en') == -1 ? 'active':''">
        <router-link :to="{ name: 'Contact'}" class="nav-link">
          <i class="fas fa-address-book"></i>
          <span>聯絡表單管理</span>
        </router-link>
      </li>
      <li class="nav-item" v-if="permission.banner_en" :class="$route.name.indexOf('Banner_en') > -1  ? 'active':''" >
        <router-link :to="{ name: 'Banner_en'}" class="nav-link">
          <i class="fas fa-image"></i>
          <span>英文版Banner管理</span>
        </router-link>
      </li>
       <li class="nav-item" v-if="permission.faculty_en" :class="$route.name.indexOf('Faculty_en') > -1 ? 'active':''">
        <router-link :to="{ name: 'Faculty_en'}" class="nav-link">
          <i class="fas fa-user"></i>
          <span>英文版中心成員管理</span>
        </router-link>
      </li>
      <li class="nav-item" v-if="permission.news_en || permission.category_en">
        <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#newsen" aria-expanded="true" aria-controls="newsen">
          <i class="fas fa-file"></i>
          <span>英文版內容管理</span>
        </a>
        <div id="newsen" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionSidebar" :class="$route.name.indexOf('News_en') > -1 || $route.name.indexOf('Category_en') > -1 ? 'show':''">
          <div class="bg-white py-2 collapse-inner rounded">
            <router-link :to="{ name: 'News_en'}" class="collapse-item" v-if="permission.news_en" :class="$route.name.indexOf('News_en') > -1 ? 'active':''" >
              <span>英文版內容列表</span>
            </router-link>
            <router-link :to="{ name: 'Category_en'}" class="collapse-item" v-if="permission.category_en" :class="$route.name.indexOf('Category_en') > -1 ? 'active':''" >
              <span>英文版類別管理</span>
            </router-link>
          </div>
        </div>
      </li>
      <li class="nav-item" v-if="permission.activity_en"  :class="$route.name.indexOf('Activity_en') > -1 ? 'active':''">
        <router-link :to="{ name: 'Activity_en'}" class="nav-link">
          <i class="fas fa-camera"></i>
          <span>英文版活動剪影管理</span>
        </router-link>
      </li>
      <li class="nav-item" v-if="permission.contact_en" :class="$route.name.indexOf('Contact_en') > -1  ? 'active':''">
        <router-link :to="{ name: 'Contact_en'}" class="nav-link">
          <i class="fas fa-address-book"></i>
          <span>英文版聯絡表單管理</span>
        </router-link>
      </li>
      <li class="nav-item" v-if="is_superuser"  :class="$route.name.indexOf('User') > -1 ? 'active':''">
        <router-link :to="{ name: 'User'}" class="nav-link">
          <i class="fas fa-users"></i>
          <span>權限管理</span>
        </router-link>
      </li>

    </ul>
    <!-- End of Sidebar -->
</template>

<script>
import {fb, db } from '../../firebase'
export default {
  name: 'Sidebar',
  data () {
    return {
      id:'',
      is_superuser:false,
      permission:{
        banner:false,
        banner_en:false,
        activity:false,
        activity_en:false,
        category:false,
        category_en:false,
        contact:false,
        contact_en:false,
        faculty:false,
        faculty_en:false,
        news:false,
        news_en:false
      }
    }
  },
  mounted() {
    
    if (localStorage.getItem("user_data")){
      this.is_superuser = localStorage.getItem("is_superuser") === 'true' ? true : false;
      this.permission = JSON.parse(localStorage.getItem("user_data"));
    } else {
      localStorage.clear();
      this.$router.push({name: '/admin/login'});
    }
  },
  methods: {
    GetPermission() {

      this.id = localStorage.getItem("user_id");

      db.collection("admin").doc(this.id).get().then((doc) => {
            if (doc.exists) {
              this.is_superuser = doc.data().is_superuser || false;
              this.permission = doc.data().permission;

            } else {
              localStorage.clear();
              this.$router.push({path: '/login'});
            }
        }).catch((error) => {
            console.log("Error getting document:", error);
        });
    }
  }
}
</script>
<style scoped>
#accordionSidebar{
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Sidebar.vue